import React from 'react';

import { CardSkeleton } from '../../Skeleton';
import useGaugeData from './useGaugeData';
import GaugeView from './GaugeView';

const GaugeContainer = ({
  gauge,
}: {
  gauge: VisualisationDefinitions.Gauge;
}) => {
  const { chartOptions } = useGaugeData({ gauge });

  if (chartOptions === undefined) {
    return <CardSkeleton />;
  }

  return <GaugeView chartOptions={chartOptions} />;
};

export default GaugeContainer;
